import { RequestService } from "../../services/RequestService";
import { GET_CUSTOMER_COMPANIES } from "../constants";

export const getCustomerCompanies = profileId => {
  return RequestService.get(
    GET_CUSTOMER_COMPANIES.replace("{company_id}", profileId)
  );
};
